module.exports = __webpack_public_path__ + "assets/img/demoAccess/success.png";